import { useMemo } from 'react';
import { OperatingSystemService } from 'ui-components/services/operating-system-service';
import { useConnectClientVersion } from '../../../feature-flags/hooks/use-connect-client-version';
import messages from './messages';

const DownloadPath = '//downloads.shipstation.com/connect/prod/shipstation';

const Mac = 'mac';
const Windows = 'win';

const latestStableConnectVersion = '4.10.0';

const downloadMap = {
  [Windows]: {
    buttonMessage: messages.winInstallButton,
    downloadAsset: 'ShipStation%20Connect%20Setup.exe',
    fallbackVersion: latestStableConnectVersion,
  },
  [Mac]: {
    buttonMessage: messages.macInstallButton,
    downloadAsset: 'ShipStation%20Connect-universal.pkg',
    fallbackVersion: latestStableConnectVersion,
  },
};

export const useGetConnectDownloadData = () => {
  const connectClientVersion = useConnectClientVersion()?.trim();
  const isMac = OperatingSystemService.isMac();

  const os = isMac ? Mac : Windows;
  const { buttonMessage, downloadAsset, fallbackVersion } = downloadMap[os];

  const version = connectClientVersion || fallbackVersion;
  const downloadUrl = `${DownloadPath}/${os}/${version}/${downloadAsset}`;

  return useMemo(() => ({ buttonMessage, downloadUrl }), [buttonMessage, downloadUrl]);
};
